import { COLORS } from '@styles/colors'
import styled from 'styled-components'

export const MapWrap = styled.div`
  width: 100%;
  height: 100%;

  .mapboxgl-ctrl-group {
    background: transparent;

    button {
      width: 32px;
      height: 32px;
      background-color: ${COLORS.white};
      border-radius: 100%;
      margin-bottom: 4px;
      box-shadow: 2px 2px 4px 0px rgba(133, 139, 173, 0.5);
      border-top: none;

      &:hover {
        background-color: ${COLORS.white} !important;
      }
    }
  }

  .mapboxgl-ctrl button.mapboxgl-ctrl-zoom-in {
    border-radius: 100% !important;

    .mapboxgl-ctrl-icon {
      background-image: url('/imgs/icons/plus.svg');
    }
  }

  .mapboxgl-ctrl button.mapboxgl-ctrl-zoom-out .mapboxgl-ctrl-icon {
    background-image: url('/imgs/icons/minus.svg');
  }

  .mapboxgl-ctrl-compass {
    display: none;
  }

  .nav-ctrl-wrapper {
    left: 10px;
    top: 10px;
  }

  .mapboxgl-ctrl {
    box-shadow: none !important;
  }

  .mapboxgl-ctrl button.mapboxgl-ctrl-fullscreen {
    border-radius: 2px;

    .mapboxgl-ctrl-icon {
      background-image: url('/imgs/icons/fullscreen.svg');
    }
  }
`
